module.exports = __webpack_public_path__ + "static/media/lamp.e6e28896.svg";